/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as StartLearningRouteImport } from './routes/start-learning'
import { Route as SecretsignupRouteImport } from './routes/secretsignup'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LearnTogetherRouteImport } from './routes/learn-together'
import { Route as ImprintRouteImport } from './routes/imprint'
import { Route as Free_trial_signupRouteImport } from './routes/free_trial_signup'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AppRouteRouteImport } from './routes/app/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppVocabulary_training_modeRouteImport } from './routes/app/vocabulary_training_mode'
import { Route as AppVocabulary_trainer_newRouteImport } from './routes/app/vocabulary_trainer_new'
import { Route as AppVocabulary_trainerRouteImport } from './routes/app/vocabulary_trainer'
import { Route as AppVocabulary_progressRouteImport } from './routes/app/vocabulary_progress'
import { Route as AppTechnical_change_logRouteImport } from './routes/app/technical_change_log'
import { Route as AppStatisticsRouteImport } from './routes/app/statistics'
import { Route as AppStartLearningRouteImport } from './routes/app/start-learning'
import { Route as AppSpace_settingsRouteImport } from './routes/app/space_settings'
import { Route as AppShoppinglistRouteImport } from './routes/app/shoppinglist'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppRead_aloud_mockupRouteImport } from './routes/app/read_aloud_mockup'
import { Route as AppQuick_translateRouteImport } from './routes/app/quick_translate'
import { Route as AppProfileRouteImport } from './routes/app/profile'
import { Route as AppProduct_logbookRouteImport } from './routes/app/product_logbook'
import { Route as AppMaison_memoireRouteImport } from './routes/app/maison_memoire'
import { Route as AppLearning_goal_dialogueRouteImport } from './routes/app/learning_goal_dialogue'
import { Route as AppLanguage_insightsRouteImport } from './routes/app/language_insights'
import { Route as AppInterest_mapRouteImport } from './routes/app/interest_map'
import { Route as AppGenerate_text_mockupRouteImport } from './routes/app/generate_text_mockup'
import { Route as AppFeature_mockupsRouteImport } from './routes/app/feature_mockups'
import { Route as AppDialogueRouteImport } from './routes/app/dialogue'
import { Route as AppCheck_your_emailRouteImport } from './routes/app/check_your_email'
import { Route as AppBark_classicRouteImport } from './routes/app/bark_classic'
import { Route as AppAccountRouteImport } from './routes/app/account'
import { Route as AppReepriseIndexRouteImport } from './routes/app/reeprise/index'
import { Route as AppReepriseGeneratedTextIdRouteImport } from './routes/app/reeprise/$generatedTextId'

const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => rootRouteImport,
} as any)
const StartLearningRoute = StartLearningRouteImport.update({
  id: '/start-learning',
  path: '/start-learning',
  getParentRoute: () => rootRouteImport,
} as any)
const SecretsignupRoute = SecretsignupRouteImport.update({
  id: '/secretsignup',
  path: '/secretsignup',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LearnTogetherRoute = LearnTogetherRouteImport.update({
  id: '/learn-together',
  path: '/learn-together',
  getParentRoute: () => rootRouteImport,
} as any)
const ImprintRoute = ImprintRouteImport.update({
  id: '/imprint',
  path: '/imprint',
  getParentRoute: () => rootRouteImport,
} as any)
const Free_trial_signupRoute = Free_trial_signupRouteImport.update({
  id: '/free_trial_signup',
  path: '/free_trial_signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppVocabulary_training_modeRoute =
  AppVocabulary_training_modeRouteImport.update({
    id: '/vocabulary_training_mode',
    path: '/vocabulary_training_mode',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppVocabulary_trainer_newRoute =
  AppVocabulary_trainer_newRouteImport.update({
    id: '/vocabulary_trainer_new',
    path: '/vocabulary_trainer_new',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppVocabulary_trainerRoute = AppVocabulary_trainerRouteImport.update({
  id: '/vocabulary_trainer',
  path: '/vocabulary_trainer',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppVocabulary_progressRoute = AppVocabulary_progressRouteImport.update({
  id: '/vocabulary_progress',
  path: '/vocabulary_progress',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTechnical_change_logRoute = AppTechnical_change_logRouteImport.update({
  id: '/technical_change_log',
  path: '/technical_change_log',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppStatisticsRoute = AppStatisticsRouteImport.update({
  id: '/statistics',
  path: '/statistics',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppStartLearningRoute = AppStartLearningRouteImport.update({
  id: '/start-learning',
  path: '/start-learning',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSpace_settingsRoute = AppSpace_settingsRouteImport.update({
  id: '/space_settings',
  path: '/space_settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppShoppinglistRoute = AppShoppinglistRouteImport.update({
  id: '/shoppinglist',
  path: '/shoppinglist',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppRead_aloud_mockupRoute = AppRead_aloud_mockupRouteImport.update({
  id: '/read_aloud_mockup',
  path: '/read_aloud_mockup',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppQuick_translateRoute = AppQuick_translateRouteImport.update({
  id: '/quick_translate',
  path: '/quick_translate',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProduct_logbookRoute = AppProduct_logbookRouteImport.update({
  id: '/product_logbook',
  path: '/product_logbook',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMaison_memoireRoute = AppMaison_memoireRouteImport.update({
  id: '/maison_memoire',
  path: '/maison_memoire',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppLearning_goal_dialogueRoute =
  AppLearning_goal_dialogueRouteImport.update({
    id: '/learning_goal_dialogue',
    path: '/learning_goal_dialogue',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppLanguage_insightsRoute = AppLanguage_insightsRouteImport.update({
  id: '/language_insights',
  path: '/language_insights',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppInterest_mapRoute = AppInterest_mapRouteImport.update({
  id: '/interest_map',
  path: '/interest_map',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppGenerate_text_mockupRoute = AppGenerate_text_mockupRouteImport.update({
  id: '/generate_text_mockup',
  path: '/generate_text_mockup',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppFeature_mockupsRoute = AppFeature_mockupsRouteImport.update({
  id: '/feature_mockups',
  path: '/feature_mockups',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDialogueRoute = AppDialogueRouteImport.update({
  id: '/dialogue',
  path: '/dialogue',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCheck_your_emailRoute = AppCheck_your_emailRouteImport.update({
  id: '/check_your_email',
  path: '/check_your_email',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBark_classicRoute = AppBark_classicRouteImport.update({
  id: '/bark_classic',
  path: '/bark_classic',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppReepriseIndexRoute = AppReepriseIndexRouteImport.update({
  id: '/reeprise/',
  path: '/reeprise/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppReepriseGeneratedTextIdRoute =
  AppReepriseGeneratedTextIdRouteImport.update({
    id: '/reeprise/$generatedTextId',
    path: '/reeprise/$generatedTextId',
    getParentRoute: () => AppRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/free_trial_signup': typeof Free_trial_signupRoute
  '/imprint': typeof ImprintRoute
  '/learn-together': typeof LearnTogetherRoute
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/secretsignup': typeof SecretsignupRoute
  '/start-learning': typeof StartLearningRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/app/account': typeof AppAccountRoute
  '/app/bark_classic': typeof AppBark_classicRoute
  '/app/check_your_email': typeof AppCheck_your_emailRoute
  '/app/dialogue': typeof AppDialogueRoute
  '/app/feature_mockups': typeof AppFeature_mockupsRoute
  '/app/generate_text_mockup': typeof AppGenerate_text_mockupRoute
  '/app/interest_map': typeof AppInterest_mapRoute
  '/app/language_insights': typeof AppLanguage_insightsRoute
  '/app/learning_goal_dialogue': typeof AppLearning_goal_dialogueRoute
  '/app/maison_memoire': typeof AppMaison_memoireRoute
  '/app/product_logbook': typeof AppProduct_logbookRoute
  '/app/profile': typeof AppProfileRoute
  '/app/quick_translate': typeof AppQuick_translateRoute
  '/app/read_aloud_mockup': typeof AppRead_aloud_mockupRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/shoppinglist': typeof AppShoppinglistRoute
  '/app/space_settings': typeof AppSpace_settingsRoute
  '/app/start-learning': typeof AppStartLearningRoute
  '/app/statistics': typeof AppStatisticsRoute
  '/app/technical_change_log': typeof AppTechnical_change_logRoute
  '/app/vocabulary_progress': typeof AppVocabulary_progressRoute
  '/app/vocabulary_trainer': typeof AppVocabulary_trainerRoute
  '/app/vocabulary_trainer_new': typeof AppVocabulary_trainer_newRoute
  '/app/vocabulary_training_mode': typeof AppVocabulary_training_modeRoute
  '/app/reeprise/$generatedTextId': typeof AppReepriseGeneratedTextIdRoute
  '/app/reeprise': typeof AppReepriseIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/free_trial_signup': typeof Free_trial_signupRoute
  '/imprint': typeof ImprintRoute
  '/learn-together': typeof LearnTogetherRoute
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/secretsignup': typeof SecretsignupRoute
  '/start-learning': typeof StartLearningRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/app/account': typeof AppAccountRoute
  '/app/bark_classic': typeof AppBark_classicRoute
  '/app/check_your_email': typeof AppCheck_your_emailRoute
  '/app/dialogue': typeof AppDialogueRoute
  '/app/feature_mockups': typeof AppFeature_mockupsRoute
  '/app/generate_text_mockup': typeof AppGenerate_text_mockupRoute
  '/app/interest_map': typeof AppInterest_mapRoute
  '/app/language_insights': typeof AppLanguage_insightsRoute
  '/app/learning_goal_dialogue': typeof AppLearning_goal_dialogueRoute
  '/app/maison_memoire': typeof AppMaison_memoireRoute
  '/app/product_logbook': typeof AppProduct_logbookRoute
  '/app/profile': typeof AppProfileRoute
  '/app/quick_translate': typeof AppQuick_translateRoute
  '/app/read_aloud_mockup': typeof AppRead_aloud_mockupRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/shoppinglist': typeof AppShoppinglistRoute
  '/app/space_settings': typeof AppSpace_settingsRoute
  '/app/start-learning': typeof AppStartLearningRoute
  '/app/statistics': typeof AppStatisticsRoute
  '/app/technical_change_log': typeof AppTechnical_change_logRoute
  '/app/vocabulary_progress': typeof AppVocabulary_progressRoute
  '/app/vocabulary_trainer': typeof AppVocabulary_trainerRoute
  '/app/vocabulary_trainer_new': typeof AppVocabulary_trainer_newRoute
  '/app/vocabulary_training_mode': typeof AppVocabulary_training_modeRoute
  '/app/reeprise/$generatedTextId': typeof AppReepriseGeneratedTextIdRoute
  '/app/reeprise': typeof AppReepriseIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/free_trial_signup': typeof Free_trial_signupRoute
  '/imprint': typeof ImprintRoute
  '/learn-together': typeof LearnTogetherRoute
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/secretsignup': typeof SecretsignupRoute
  '/start-learning': typeof StartLearningRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/app/account': typeof AppAccountRoute
  '/app/bark_classic': typeof AppBark_classicRoute
  '/app/check_your_email': typeof AppCheck_your_emailRoute
  '/app/dialogue': typeof AppDialogueRoute
  '/app/feature_mockups': typeof AppFeature_mockupsRoute
  '/app/generate_text_mockup': typeof AppGenerate_text_mockupRoute
  '/app/interest_map': typeof AppInterest_mapRoute
  '/app/language_insights': typeof AppLanguage_insightsRoute
  '/app/learning_goal_dialogue': typeof AppLearning_goal_dialogueRoute
  '/app/maison_memoire': typeof AppMaison_memoireRoute
  '/app/product_logbook': typeof AppProduct_logbookRoute
  '/app/profile': typeof AppProfileRoute
  '/app/quick_translate': typeof AppQuick_translateRoute
  '/app/read_aloud_mockup': typeof AppRead_aloud_mockupRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/shoppinglist': typeof AppShoppinglistRoute
  '/app/space_settings': typeof AppSpace_settingsRoute
  '/app/start-learning': typeof AppStartLearningRoute
  '/app/statistics': typeof AppStatisticsRoute
  '/app/technical_change_log': typeof AppTechnical_change_logRoute
  '/app/vocabulary_progress': typeof AppVocabulary_progressRoute
  '/app/vocabulary_trainer': typeof AppVocabulary_trainerRoute
  '/app/vocabulary_trainer_new': typeof AppVocabulary_trainer_newRoute
  '/app/vocabulary_training_mode': typeof AppVocabulary_training_modeRoute
  '/app/reeprise/$generatedTextId': typeof AppReepriseGeneratedTextIdRoute
  '/app/reeprise/': typeof AppReepriseIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/about'
    | '/free_trial_signup'
    | '/imprint'
    | '/learn-together'
    | '/login'
    | '/pricing'
    | '/privacy-policy'
    | '/secretsignup'
    | '/start-learning'
    | '/terms-of-service'
    | '/app/account'
    | '/app/bark_classic'
    | '/app/check_your_email'
    | '/app/dialogue'
    | '/app/feature_mockups'
    | '/app/generate_text_mockup'
    | '/app/interest_map'
    | '/app/language_insights'
    | '/app/learning_goal_dialogue'
    | '/app/maison_memoire'
    | '/app/product_logbook'
    | '/app/profile'
    | '/app/quick_translate'
    | '/app/read_aloud_mockup'
    | '/app/settings'
    | '/app/shoppinglist'
    | '/app/space_settings'
    | '/app/start-learning'
    | '/app/statistics'
    | '/app/technical_change_log'
    | '/app/vocabulary_progress'
    | '/app/vocabulary_trainer'
    | '/app/vocabulary_trainer_new'
    | '/app/vocabulary_training_mode'
    | '/app/reeprise/$generatedTextId'
    | '/app/reeprise'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app'
    | '/about'
    | '/free_trial_signup'
    | '/imprint'
    | '/learn-together'
    | '/login'
    | '/pricing'
    | '/privacy-policy'
    | '/secretsignup'
    | '/start-learning'
    | '/terms-of-service'
    | '/app/account'
    | '/app/bark_classic'
    | '/app/check_your_email'
    | '/app/dialogue'
    | '/app/feature_mockups'
    | '/app/generate_text_mockup'
    | '/app/interest_map'
    | '/app/language_insights'
    | '/app/learning_goal_dialogue'
    | '/app/maison_memoire'
    | '/app/product_logbook'
    | '/app/profile'
    | '/app/quick_translate'
    | '/app/read_aloud_mockup'
    | '/app/settings'
    | '/app/shoppinglist'
    | '/app/space_settings'
    | '/app/start-learning'
    | '/app/statistics'
    | '/app/technical_change_log'
    | '/app/vocabulary_progress'
    | '/app/vocabulary_trainer'
    | '/app/vocabulary_trainer_new'
    | '/app/vocabulary_training_mode'
    | '/app/reeprise/$generatedTextId'
    | '/app/reeprise'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/about'
    | '/free_trial_signup'
    | '/imprint'
    | '/learn-together'
    | '/login'
    | '/pricing'
    | '/privacy-policy'
    | '/secretsignup'
    | '/start-learning'
    | '/terms-of-service'
    | '/app/account'
    | '/app/bark_classic'
    | '/app/check_your_email'
    | '/app/dialogue'
    | '/app/feature_mockups'
    | '/app/generate_text_mockup'
    | '/app/interest_map'
    | '/app/language_insights'
    | '/app/learning_goal_dialogue'
    | '/app/maison_memoire'
    | '/app/product_logbook'
    | '/app/profile'
    | '/app/quick_translate'
    | '/app/read_aloud_mockup'
    | '/app/settings'
    | '/app/shoppinglist'
    | '/app/space_settings'
    | '/app/start-learning'
    | '/app/statistics'
    | '/app/technical_change_log'
    | '/app/vocabulary_progress'
    | '/app/vocabulary_trainer'
    | '/app/vocabulary_trainer_new'
    | '/app/vocabulary_training_mode'
    | '/app/reeprise/$generatedTextId'
    | '/app/reeprise/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AboutRoute: typeof AboutRoute
  Free_trial_signupRoute: typeof Free_trial_signupRoute
  ImprintRoute: typeof ImprintRoute
  LearnTogetherRoute: typeof LearnTogetherRoute
  LoginRoute: typeof LoginRoute
  PricingRoute: typeof PricingRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  SecretsignupRoute: typeof SecretsignupRoute
  StartLearningRoute: typeof StartLearningRoute
  TermsOfServiceRoute: typeof TermsOfServiceRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/start-learning': {
      id: '/start-learning'
      path: '/start-learning'
      fullPath: '/start-learning'
      preLoaderRoute: typeof StartLearningRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/secretsignup': {
      id: '/secretsignup'
      path: '/secretsignup'
      fullPath: '/secretsignup'
      preLoaderRoute: typeof SecretsignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/learn-together': {
      id: '/learn-together'
      path: '/learn-together'
      fullPath: '/learn-together'
      preLoaderRoute: typeof LearnTogetherRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/imprint': {
      id: '/imprint'
      path: '/imprint'
      fullPath: '/imprint'
      preLoaderRoute: typeof ImprintRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/free_trial_signup': {
      id: '/free_trial_signup'
      path: '/free_trial_signup'
      fullPath: '/free_trial_signup'
      preLoaderRoute: typeof Free_trial_signupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/vocabulary_training_mode': {
      id: '/app/vocabulary_training_mode'
      path: '/vocabulary_training_mode'
      fullPath: '/app/vocabulary_training_mode'
      preLoaderRoute: typeof AppVocabulary_training_modeRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/vocabulary_trainer_new': {
      id: '/app/vocabulary_trainer_new'
      path: '/vocabulary_trainer_new'
      fullPath: '/app/vocabulary_trainer_new'
      preLoaderRoute: typeof AppVocabulary_trainer_newRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/vocabulary_trainer': {
      id: '/app/vocabulary_trainer'
      path: '/vocabulary_trainer'
      fullPath: '/app/vocabulary_trainer'
      preLoaderRoute: typeof AppVocabulary_trainerRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/vocabulary_progress': {
      id: '/app/vocabulary_progress'
      path: '/vocabulary_progress'
      fullPath: '/app/vocabulary_progress'
      preLoaderRoute: typeof AppVocabulary_progressRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/technical_change_log': {
      id: '/app/technical_change_log'
      path: '/technical_change_log'
      fullPath: '/app/technical_change_log'
      preLoaderRoute: typeof AppTechnical_change_logRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/statistics': {
      id: '/app/statistics'
      path: '/statistics'
      fullPath: '/app/statistics'
      preLoaderRoute: typeof AppStatisticsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/start-learning': {
      id: '/app/start-learning'
      path: '/start-learning'
      fullPath: '/app/start-learning'
      preLoaderRoute: typeof AppStartLearningRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/space_settings': {
      id: '/app/space_settings'
      path: '/space_settings'
      fullPath: '/app/space_settings'
      preLoaderRoute: typeof AppSpace_settingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/shoppinglist': {
      id: '/app/shoppinglist'
      path: '/shoppinglist'
      fullPath: '/app/shoppinglist'
      preLoaderRoute: typeof AppShoppinglistRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/read_aloud_mockup': {
      id: '/app/read_aloud_mockup'
      path: '/read_aloud_mockup'
      fullPath: '/app/read_aloud_mockup'
      preLoaderRoute: typeof AppRead_aloud_mockupRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/quick_translate': {
      id: '/app/quick_translate'
      path: '/quick_translate'
      fullPath: '/app/quick_translate'
      preLoaderRoute: typeof AppQuick_translateRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/profile': {
      id: '/app/profile'
      path: '/profile'
      fullPath: '/app/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/product_logbook': {
      id: '/app/product_logbook'
      path: '/product_logbook'
      fullPath: '/app/product_logbook'
      preLoaderRoute: typeof AppProduct_logbookRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/maison_memoire': {
      id: '/app/maison_memoire'
      path: '/maison_memoire'
      fullPath: '/app/maison_memoire'
      preLoaderRoute: typeof AppMaison_memoireRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/learning_goal_dialogue': {
      id: '/app/learning_goal_dialogue'
      path: '/learning_goal_dialogue'
      fullPath: '/app/learning_goal_dialogue'
      preLoaderRoute: typeof AppLearning_goal_dialogueRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/language_insights': {
      id: '/app/language_insights'
      path: '/language_insights'
      fullPath: '/app/language_insights'
      preLoaderRoute: typeof AppLanguage_insightsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/interest_map': {
      id: '/app/interest_map'
      path: '/interest_map'
      fullPath: '/app/interest_map'
      preLoaderRoute: typeof AppInterest_mapRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/generate_text_mockup': {
      id: '/app/generate_text_mockup'
      path: '/generate_text_mockup'
      fullPath: '/app/generate_text_mockup'
      preLoaderRoute: typeof AppGenerate_text_mockupRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/feature_mockups': {
      id: '/app/feature_mockups'
      path: '/feature_mockups'
      fullPath: '/app/feature_mockups'
      preLoaderRoute: typeof AppFeature_mockupsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/dialogue': {
      id: '/app/dialogue'
      path: '/dialogue'
      fullPath: '/app/dialogue'
      preLoaderRoute: typeof AppDialogueRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/check_your_email': {
      id: '/app/check_your_email'
      path: '/check_your_email'
      fullPath: '/app/check_your_email'
      preLoaderRoute: typeof AppCheck_your_emailRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/bark_classic': {
      id: '/app/bark_classic'
      path: '/bark_classic'
      fullPath: '/app/bark_classic'
      preLoaderRoute: typeof AppBark_classicRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/account': {
      id: '/app/account'
      path: '/account'
      fullPath: '/app/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/reeprise/': {
      id: '/app/reeprise/'
      path: '/reeprise'
      fullPath: '/app/reeprise'
      preLoaderRoute: typeof AppReepriseIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/reeprise/$generatedTextId': {
      id: '/app/reeprise/$generatedTextId'
      path: '/reeprise/$generatedTextId'
      fullPath: '/app/reeprise/$generatedTextId'
      preLoaderRoute: typeof AppReepriseGeneratedTextIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppRouteRouteChildren {
  AppAccountRoute: typeof AppAccountRoute
  AppBark_classicRoute: typeof AppBark_classicRoute
  AppCheck_your_emailRoute: typeof AppCheck_your_emailRoute
  AppDialogueRoute: typeof AppDialogueRoute
  AppFeature_mockupsRoute: typeof AppFeature_mockupsRoute
  AppGenerate_text_mockupRoute: typeof AppGenerate_text_mockupRoute
  AppInterest_mapRoute: typeof AppInterest_mapRoute
  AppLanguage_insightsRoute: typeof AppLanguage_insightsRoute
  AppLearning_goal_dialogueRoute: typeof AppLearning_goal_dialogueRoute
  AppMaison_memoireRoute: typeof AppMaison_memoireRoute
  AppProduct_logbookRoute: typeof AppProduct_logbookRoute
  AppProfileRoute: typeof AppProfileRoute
  AppQuick_translateRoute: typeof AppQuick_translateRoute
  AppRead_aloud_mockupRoute: typeof AppRead_aloud_mockupRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppShoppinglistRoute: typeof AppShoppinglistRoute
  AppSpace_settingsRoute: typeof AppSpace_settingsRoute
  AppStartLearningRoute: typeof AppStartLearningRoute
  AppStatisticsRoute: typeof AppStatisticsRoute
  AppTechnical_change_logRoute: typeof AppTechnical_change_logRoute
  AppVocabulary_progressRoute: typeof AppVocabulary_progressRoute
  AppVocabulary_trainerRoute: typeof AppVocabulary_trainerRoute
  AppVocabulary_trainer_newRoute: typeof AppVocabulary_trainer_newRoute
  AppVocabulary_training_modeRoute: typeof AppVocabulary_training_modeRoute
  AppReepriseGeneratedTextIdRoute: typeof AppReepriseGeneratedTextIdRoute
  AppReepriseIndexRoute: typeof AppReepriseIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppAccountRoute: AppAccountRoute,
  AppBark_classicRoute: AppBark_classicRoute,
  AppCheck_your_emailRoute: AppCheck_your_emailRoute,
  AppDialogueRoute: AppDialogueRoute,
  AppFeature_mockupsRoute: AppFeature_mockupsRoute,
  AppGenerate_text_mockupRoute: AppGenerate_text_mockupRoute,
  AppInterest_mapRoute: AppInterest_mapRoute,
  AppLanguage_insightsRoute: AppLanguage_insightsRoute,
  AppLearning_goal_dialogueRoute: AppLearning_goal_dialogueRoute,
  AppMaison_memoireRoute: AppMaison_memoireRoute,
  AppProduct_logbookRoute: AppProduct_logbookRoute,
  AppProfileRoute: AppProfileRoute,
  AppQuick_translateRoute: AppQuick_translateRoute,
  AppRead_aloud_mockupRoute: AppRead_aloud_mockupRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppShoppinglistRoute: AppShoppinglistRoute,
  AppSpace_settingsRoute: AppSpace_settingsRoute,
  AppStartLearningRoute: AppStartLearningRoute,
  AppStatisticsRoute: AppStatisticsRoute,
  AppTechnical_change_logRoute: AppTechnical_change_logRoute,
  AppVocabulary_progressRoute: AppVocabulary_progressRoute,
  AppVocabulary_trainerRoute: AppVocabulary_trainerRoute,
  AppVocabulary_trainer_newRoute: AppVocabulary_trainer_newRoute,
  AppVocabulary_training_modeRoute: AppVocabulary_training_modeRoute,
  AppReepriseGeneratedTextIdRoute: AppReepriseGeneratedTextIdRoute,
  AppReepriseIndexRoute: AppReepriseIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  AboutRoute: AboutRoute,
  Free_trial_signupRoute: Free_trial_signupRoute,
  ImprintRoute: ImprintRoute,
  LearnTogetherRoute: LearnTogetherRoute,
  LoginRoute: LoginRoute,
  PricingRoute: PricingRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  SecretsignupRoute: SecretsignupRoute,
  StartLearningRoute: StartLearningRoute,
  TermsOfServiceRoute: TermsOfServiceRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
